<template>
  <div class="container">
    <table class="table table-striped" style="border: 1px solid #000;">
      <thead>
        <tr>
          <th  scope="col" colspan="2">Variables</th>
          <th  scope="col">{{ Yeartwo }}</th>
          <th  scope="col">{{ YearOne }}</th>
          <th  scope="col">{{ varEntorno }}</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <th scope="row" colspan="2">{{ textOne }}</th>
          <td>
            <input disabled class="inputs" v-model="ingresoContrata.inputOne" />
          </td>
          <td>
            <input disabled class="inputs" v-model="ingresoContrata.inputTwo" />
          </td>
          <td>
            <input
              disabled
              v-model="ingresoContrata.inputThree"
              class="inputs"
            />
          </td>
        </tr>
        <tr>
          <th scope="row" colspan="2">{{ textTwo }}</th>
          <td>
            <input
              disabled
              v-model="honorariosRegularizado.inputFour"
              class="inputs"
            />
          </td>
          <td>
            <input
              disabled
              v-model="honorariosRegularizado.inputFive"
              class="inputs"
            />
          </td>
          <td>
            <input
              disabled
              v-model="honorariosRegularizado.inputSix"
              class="inputs"
            />
          </td>
        </tr>
        <tr>
          <th scope="row" colspan="2">{{ textThree }}</th>
          <td  class="inputs">{{ intPorcentajeOne }}%</td>
          <td  class="inputs">{{ intPorcentajeTwo }}%</td>
          <td  class="inputs">{{ intPorcentajeThree }}%</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
// import store from "../../../../../../store";
export default {
  props: ["procesoRegularizacion", "ingresoContrata", "honorariosRegularizado"],
  data() {
    return {
      textOne:
        "(a) N° de personas a honorarios traspasadas a la contrata año t",
      textTwo: "(b) N° de personas a honorarios regularizables año t-1",
      textThree: "Porcentaje de honorarios regularizados (a/b)",
      varEntorno: `${process.env.VUE_APP_ANIO}`,
      YearOne: "",
      Yeartwo: "",
      YearThre: "",
      data: "1",
      dataTwo: "2",

      porcentajeOne: "",
      porcentajeTwo: "",
      porcentajeThree: "",
      porcentaje: "100",
      intPorcentajeOne: null,
      intPorcentajeTwo: null,
      intPorcentajeThree: null,
      arrayFather: null,
    };
  },

  mounted() {
    this.YearOne = parseInt(this.varEntorno) - parseInt(this.data);
    this.Yeartwo = parseInt(this.varEntorno) - parseInt(this.dataTwo);
    // this.arrayFunction();
  },
  updated() {
    // Primer porcentaje
    this.porcentajeOne =
      (parseInt(this.ingresoContrata.inputOne) /
        parseInt(this.honorariosRegularizado.inputFour)) *
      parseInt(this.porcentaje);
    this.intPorcentajeOne = this.porcentajeOne.toFixed(2);

    //Segundo Porcentaje
    this.porcentajeTwo =
      (parseInt(this.ingresoContrata.inputTwo) /
        parseInt(this.honorariosRegularizado.inputFive)) *
      parseInt(this.porcentaje);
    this.intPorcentajeTwo = this.porcentajeTwo.toFixed(2);

    //Tercer Porcentaje
    this.porcentajeThree =
      (parseInt(this.ingresoContrata.inputThree) /
        parseInt(this.honorariosRegularizado.inputSix)) *
      parseInt(this.porcentaje);
    this.intPorcentajeThree = this.porcentajeThree.toFixed(2);

    // store.dispatch("rHumanos/actionsTable", {
    //   value: [
    //     {
    //       title: this.textOne,
    //       anioTwo: this.inputOne,
    //       anioOne: this.inputTwo,
    //       anio: this.inputThree,
    //     },
    //     {
    //       title: this.textTwo,
    //       anioTwo: this.inputFour,
    //       anioOne: this.inputFive,
    //       anio: this.inputSix,
    //     },
    //     {
    //       title: this.textThree,
    //       anioTwo: `${this.intPorcentajeOne}%`,
    //       anioOne: `${this.intPorcentajeTwo}%`,
    //       anio: `${this.intPorcentajeThree}%`,
    //     },
    //   ],
    //   nameTable: "procesoRegularizacion",
    // });
  },
};
</script>

<style scoped>
th {
  text-align: left !important;
  font-size: 14px !important ;
}

.div {
  border: 1px solid #000;
  width: 96%;
  height: 26px;
  position: relative;
  left: 3px;
  background-color: #fff;
}

.inputs{
  border: none;
  text-align: left;
}
</style>
